import { SiteLayout } from '@/components/site/SiteLayout'
import { PolicyShell, PolicySection } from '@/components/site/PolicyShell'

const UPDATED = '2026-05-25'

export function SecurityPage() {
  return (
    <SiteLayout>
      <PolicyShell title="Security" updated={UPDATED}>
        <PolicySection heading="Posture">
          <p>
            GeoBorder is a free service and operates on a best-effort security
            posture appropriate for that scale. We've made reasonable design
            choices to protect account credentials and developer API keys, but
            no online service can be guaranteed completely secure.
          </p>
        </PolicySection>

        <PolicySection heading="Transport">
          <ul>
            <li>
              Every page and API endpoint is served over HTTPS only. HSTS is
              enabled with a long max-age.
            </li>
            <li>
              The developer API surface (<code>api.geoborder.us/v1/…</code>)
              and the public same-origin endpoint (<code>geoborder.us/api/…</code>)
              both require TLS.
            </li>
          </ul>
        </PolicySection>

        <PolicySection heading="Credentials">
          <ul>
            <li>
              Account passwords are hashed by our authentication provider
              before storage. We never receive or store your plaintext
              password.
            </li>
            <li>
              Developer API keys are stored as SHA-256 hashes. The plaintext
              key is generated server-side and shown to you exactly once at
              creation; we cannot recover it if lost.
            </li>
            <li>
              Keys can be revoked instantly from your account dashboard.
              Revoked keys stop authenticating on the next request.
            </li>
          </ul>
        </PolicySection>

        <PolicySection heading="Authorization model">
          <ul>
            <li>
              Database row-level security is enabled on every table.
            </li>
            <li>
              Browser-callable RPCs are explicitly scoped; service-level keys
              never ship to the browser bundle.
            </li>
            <li>
              The public map endpoint enforces an origin allow-list plus a
              per-IP rate limit; the developer API enforces a per-key tier
              with both per-minute and per-day caps.
            </li>
          </ul>
        </PolicySection>

        <PolicySection heading="Reporting issues">
          <p>
            If you discover a security issue, please report it responsibly
            through whichever channel you used to learn about the service.
            We don't operate a dedicated disclosure inbox or bug-bounty
            program; in the spirit of free / open-source projects we ask for
            good-faith disclosure and reasonable time to address findings
            before they're shared publicly.
          </p>
        </PolicySection>

        <PolicySection heading="Limits">
          <p>
            This service is provided as-is, without any warranty of security,
            availability, or fitness for any particular purpose. Use it at
            your own risk. See the <a href="/terms">Terms of Use</a> for the
            governing terms.
          </p>
        </PolicySection>
      </PolicyShell>
    </SiteLayout>
  )
}
